import { lazy } from 'react'
import { RdotUserRoleEnum } from '../../../../../../store/user/rdotUser'
import { IAccountsModuleDefintion } from '../../shared/IAccountsModuleDefinition'

const ManagedAccountFeeHistoryContainer = lazy(
  () => import('./ManagedAccountFeeHistoryContainer')
)

const moduleDefinition: IAccountsModuleDefintion = {
  routeProps: {
    path: '/ManagedAccountFeeHistory',
    private: true,
    component: ManagedAccountFeeHistoryContainer
  },
  showRepSelector: true,
  roles: [RdotUserRoleEnum.Advisory_User],
  name: 'Managed Account Fees'
}

export * from './store'
export default moduleDefinition
